<template>
  <div>
    <b-modal v-model="isTrustedIdNumbersCardModalActive" class="trusted-id-modal" scroll="keep" :can-cancel="['escape', 'outside']">
      <trusted-id-numbers @is-modal-active="isTrustedIdNumbersCardModalActive=$event" />
    </b-modal>
    <div class="header-content">
      <a :class="$store.state.currentUser == null ? 'creditu-login-logo' : 'creditu-logo'" @click="() => { $router.push({ name: 'dashboard' }); }">
        <img src="@/ui/assets/img/logo-creditu.svg" alt="logo-creditu">
      </a>
      <div v-if="$store.state.currentUser !== null" class="header-item p-3 is-flex is-flex-direction-row-reverse is-align-items-center" :class="{ 'scroll-active': isScrolling }">
        <div
          v-if="currentUser !== null"
          class="bars-menu"
          :class="openMenu ? 'active': ''"
          @click="openMenuEmit">
          <span />
          <span />
          <span />
        </div>
        <div v-if="$store.state.currentUser !== null" class="user-menu">
          <template>
            <b-dropdown
              id="dropdownMyProfile"
              aria-role="list"
              class="is-pulled-right"
              position="is-bottom-left"
              :mobile-modal="false">
              <template #trigger>
                <AvatarShow />
                <span class="user-name">{{ $store.state.currentUser !== null ? $store.state.currentUser.user.name : '' }}</span>
              </template>
              <b-dropdown-item
                class="profile-my-account"
                aria-role="listitem"
                @click="() => { $router.push({ name: 'change-details' }); }">
                {{ $t('sidebar.perfil') }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$i18n.locale==='cl' && $store.state.currentUser &&
                  ($store.state.currentUser.user.allowedFrontRoutesNames?.includes('pay-here')
                    || $store.state.currentUser.user.allowedUserFeatures?.includes('element.header.trusted-id')
                  )"
                id="button-trusted-id-numbers"
                data-cy="button-trusted-id-numbers"
                class="trusted-id"
                @click="isTrustedIdNumbersCardModalActive = true">
                Personas de confianza
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$store.state.currentUser.user.rol !== 'CLIENT'"
                id="button-board"
                class="board-btn"
                aria-role="listitem"
                @click="openUrl('boards')">
                Board
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$store.state.currentUser.user.rol !== 'CLIENT'"
                id="button-wiki"
                class="wiki-btn"
                aria-role="listitem"
                @click="openUrl('wiki')">
                Wiki
              </b-dropdown-item>
              <b-dropdown-item
                id="button-logout"
                class="profile-logout"
                aria-role="listitem"
                @click="logout">
                {{ $t('sidebar.logout') }}
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </div>
        <div
          v-if="$store.state.currentUser &&
            ($store.state.currentUser.user.allowedFrontRoutesNames?.includes('support')
              || $store.state.currentUser.user.allowedUserFeatures?.includes('nav.sidebar.support')
              || $store.state.currentUser.user.rol == 'ADMIN'
              || $store.state.currentUser.user.rol == 'CLIENT'
            )"
          class="is-pulled-right config-menu">
          <div class="is-flex">
            <span
              class="mr-1">
              <b-button
                id="support-link"
                data-cy="support-link"
                icon-left="fas fa-headset"
                type="is-primary"
                @click="() => { $router.push({ name: 'support' })}">{{ $t('clientRouter.help') }}
              </b-button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { authenticationService } from '@/application/services/api-clients/login-service';
import AvatarShow from '@/ui/components/input/avatar/AvatarShow.vue';
import trustedIdNumbers from './internal/settings/TrustedIdNumbers.vue';

export default {
  name: 'Header',
  components: { AvatarShow, trustedIdNumbers },
  props: {
    openMenu: Boolean
  },
  data() {
    return {
      currentUser: 1,
      userIdsByCountry: { cl: '', br: '', pe: '' },
      isTrustedIdNumbersCardModalActive: false,
      isScrolling: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // haveToShowCountryChange() {
    //   const isLoguedUser = !!this.$store.state?.currentUser;
    //   const isClient = this.$store.state.currentUser?.user?.rol === 'CLIENT';
    //   const haveToShow = isLoguedUser && !isClient && this.checkUserFeature('nav.sidebar.change-country');
    //   return haveToShow;
    // },
    // checkUserFeature(name) {
    //   return userFeatures.methods.checkUserFeature(name, this.$store);
    // },
    // allowCountryForChange(country) {
    //   const id = this.userIdsByCountry[country];
    //   return !!id;
    // },
    // changeCountry(newCountry) {
    //   const actualCountry = this.$i18n.locale;
    //   const newUrl = window.location.href.split(`/${actualCountry}/`).join(`/${newCountry}/`);
    //   window.location.href = newUrl;
    // },
    handleScroll() {
      this.isScrolling = window.scrollY > 0;
    },
    isCheckIn(routeName, checkIn) {
      if (!checkIn && routeName === 'check-in') return true;
      if (!checkIn) return false;
      if (checkIn.is || !checkIn.required) {
        if (routeName === 'check-in') return true;
      }
      if (!checkIn.is && checkIn.required) {
        if (routeName !== 'check-in') return true;
      }
      return false;
    },
    openMenuEmit() {
      const toggleValue = !this.openMenu;
      this.$emit('openMenu', toggleValue);
    },
    async sendLogoutAction() {
      try {
        if (!(this.$store.state.currentUser && this.$store.state.currentUser.user)) {
          return;
        }
        const action = {
          country: this.$i18n.locale,
          view: this.$route.name,
          user_id: this.$store.state.currentUser.user._id,
          user_rol: this.$store.state.currentUser.user.rol,
          executed_at: new Date(),
          action: 'logout'
        };
        if (this.$store.state.currentUser.user.rol === 'INVESTOR' && this.$store.state.currentUser.user.investorsIds) {
          action.metadata = { investorsIds: this.$store.state.currentUser.user.investorsIds };
        }
        // this.$socket.emit('action', action);
      } catch (error) {
        this.$log.error('Error al enviar action logout', error);
      }
    },
    async logout() {
      try {
        await this.sendLogoutAction();
      } catch (error) {
        this.$log.error('Logout action event failed');
        this.$log.error(error);
      }
      window.location.pathname = `${this.$i18n.locale}/`;
      await authenticationService.logout();
      this.$router.push({ name: 'login' });
    },
    openUrl(link) {
      const url = `https://${link}.creditu.com`;
      window.open(url, '_blank');
    }
  }
};
</script>
<style lang="css">

.header-item {
  background: #ffffff;
  border-radius: 10px;
  width: fit-content;
  float: right;
  border: 1px solid #eaeaea;
}
.scroll-active {
  /* Estilos cuando el scroll es mayor que 0 */
  box-shadow: 0px 0px 30px #00000015;
}
.icon--b:hover {
  vertical-align: middle;
  cursor: pointer;
}
.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem
}
.avatar > img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
.profile-cover-avatar .avatar-img {
  display: block;
  max-width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  pointer-events: none;
  border-radius: 50%;
}
.user-menu .user-name {
  margin-left: 10px;
}
.user-menu .profile-cover-avatar {
  display: -ms-flexbox;
  display: flex;
  margin: 0;
  border: 3px solid #fff;
  border-radius: 50%;;
}
.dropdown-trigger{
  display: flex;
  align-items: center;
}
.config-menu {
  color: #9d9d9d;
  margin: 0 1rem;
}
.config-menu:hover {
  color: var(--primary);
}
@media (min-width: 768px) {
  .avatar-xxl {
    width: 8rem;
    height: 8rem;
  }
}

.avatar-xs .border {
  border-width: 2px !important;
}
.avatar-xs .rounded {
  border-radius: 4px !important;
}
.avatar-xs .avatar-title {
  font-size: 12px;
}
.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.avatar-sm .border {
  border-width: 3px !important;
}
.avatar-sm .rounded {
  border-radius: 4px !important;
}
.avatar-sm .avatar-title {
  font-size: 15px;
}
.avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}
.avatar-lg .border {
  border-width: 3px !important;
}
.avatar-lg .rounded {
  border-radius: 8px !important;
}
.avatar-lg .avatar-title {
  font-size: 24px;
}
.avatar-xl {
  width: 5rem;
  height: 5rem;
}
.avatar-xl .border {
  border-width: 4px !important;
}
.avatar-xl .rounded {
  border-radius: 8px !important;
}
    .header-content {
        position: fixed;
        width: inherit;
    }
    .header-content .creditu-logo {
      position: relative;
      margin: 15px 15px 0 0px;
      overflow: hidden;
      float: left;
      width: 150px;
      display: none;
    }
    .header-content .creditu-login-logo {
      position: fixed;
      left: calc(50%);
    transform: translate(-50%, 0);
      width: 140px;
    }
    .header-content .content-top-menu {
        font-size: 15px;
        margin-top: 0px;
        line-height: 10px;
        color: #00CCD1;
        text-align: right;
        margin-right: 30px;
        font-family: var(--secondary-font);
        float: right;
    }
    .header-content .content-top-menu span {
        margin-right: 9px;
    }
    .header-content .bars-menu {
        position: relative;
        z-index: 999;
      margin: 5px;
        overflow: hidden;
        font-size: 20px;
        display: none;
        color: var(--primary);
        cursor: pointer;
        -webkit-transition-duration: 0.25s;
        transition-duration: 0.25s;
        width: 29px;
        height: 25px;
    }
    .header-content .bars-menu span{
        display: block;
        width: 29px;
        height: 4px;
        margin-bottom: 5px;
        position: relative;
        background: var(--primary);
        border-radius: 3px;
        z-index: 1;
        transform-origin: 4px 0px;
        transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0);
    }
    .header-content .bars-menu span:first-child{
        transform-origin: 0% 0%;
    }

    .header-content .bars-menu span:nth-last-child(2){
        transform-origin: 0% 100%;
    }
    .header-content .bars-menu.active span{
        opacity: 1;
        transform: rotate(45deg) translate(-7px, -12px);
        background: var(--primary);
    }
    .header-content .bars-menu.active span:nth-last-child(2){
        opacity: 0;
        transform: rotate(0deg) scale(0.2, 0.2);
    }
    .header-content .bars-menu.active span:nth-last-child(3){
        transform: rotate(-45deg) translate(-14px, 17px);
    }
    .user-menu{
      margin-right: 15px;
    }
    div.user-menu:hover{
      color:  #00CCD1;
      cursor: pointer;
    }
    .router-style{
      color: #4a4a4a;
    }
    .trusted-id-modal {
      z-index: 9999;
    }
    @media (max-width: 1024px) {
        .header-content .content-top-menu{
            font-size: 12px;
        }
    }
    @media (max-width: 910px) {
      .creditu-logo {
        display: block !important;
      }
        .header-content .content-top-menu{
            font-size: 10px;
        }
.header-content .bars-menu{
          display: block;
          float: right;
        }
        .user-name{
          display: none;
        }
        .icon-margin{
          margin-left: -10px;
        }
    }
    @media (max-width: 580px) {
      .config-menu {
        display: none;
      }
      .header-content {
        zoom: 80%;
      }
    }
    @media (max-width: 300px) {
      .header-content {
        zoom: 70%;
      }
    }
</style>
